import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
// import 'react-data-table-component-extensions/dist/utilities';
import {CSVLink} from 'react-csv';
import { ExportToExcelLive } from '../Excelfile';
import Navbar from '../Navbar';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import Loaders from './Spinners/Loaders';


const Sapinventory = () => {
    
    const navigate = useNavigate();

    
    const [userData, setUserData] = useState({});        
    const senempmapdata = userData.empCode;       
    const [values, setValues] = useState([]);
    const [selectinvsitedata, setSelectinvsitedata] = useState();
    const [selectinvlocationdata, setSelectinvlocationdata] = useState();
    const [finalinvdata, setFinalinvdata] = useState([]);
    const [finalsapinvdata, setFinalsapinvdata] = useState([]);
    const [finalsaptraninvdata, setFinalsaptraninvdata] = useState([]);
    const [btnsearch, setBtnsearch] = useState('');
    const [plantdata, setPlantdata] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    

    function formatDate(date) {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) 
    month = '0' + month;
  if (day.length < 2) 
    day = '0' + day;

  return [year, month, day].join('');
}

    const today = new Date();
    const pastDate = new Date();
    pastDate.setDate(today.getDate() - 30);
    const sapfromDate = formatDate(pastDate);
    const saptoDate = formatDate(today);

    const empsitemapdata = async () => {
        
        try {
            if(!senempmapdata)
            {
                toast.error("Please Connect to QRS-Administration.", { position: "top-center" });
            }
            else
            {
            const res = await fetch('/tcsdb/sitemapdata/'+senempmapdata, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            const empsitemapdata = await res.json();
            if(res.status === 404)
            {
                toast.error("You have Zero Data Available.", { position: "top-center" });
            }
            else
            {            
            setValues(empsitemapdata);            
            }
        }
        } catch (err) {
            console.log(err);
            
        }

    }


    const empdataHomePage = async () => {
        try {
            const res = await fetch('/user/empmasterdata');
            const empdata = await res.json();        
            setUserData(empdata);             
        } catch (err) {
            console.log(err);
            
        }
    
    }


    const handlesitelistdata = async(e) => {
      setSelectinvsitedata(e.target.value);
            const sitefvaluedata = e.target.value;
            if(sitefvaluedata === "--Select--")
              {
                  toast.error("Please Select the Site Data.", { position: "top-center" });
              } 
              else{
            const sitenamefvalue = values.filter((fdata) => (fdata.siteCode === sitefvaluedata))
            setSelectinvsitedata(sitefvaluedata);
            // console.log(sitenamefvalue);
            setPlantdata(sitenamefvalue[0].plant);
            // console.log(hqnamefvalue[0].hqName);
              }
          }

    
    const divwiseinventoryreport = async () => {        
      try {
          let frontsitedata = selectinvsitedata;
          let frontlocationdata = selectinvlocationdata;
          let locationtypedata = "";
          let locationsdata = "";
          if(frontlocationdata === "Inventory")
          {
            locationtypedata = "Inventory";
            locationsdata = "FG Saleable Stock";
          }
          
          if(frontlocationdata === "Goods-intransit")
          {
            locationtypedata = "Goods-intransit";
            locationsdata = "Goods Intransit Location";
          }

          if(!frontsitedata ||!locationtypedata || !locationsdata || frontlocationdata === "--Select--"|| frontsitedata === "--Select--")
          {
              toast.error("Please Select the Site Data.", { position: "top-center" });
          }          
          else
          {
            setBtnsearch('none');
            setIsLoading(true);
          const data = { entityNames:"", actions:"", sites:"", locationTypes:"", locations:"", itemTypes:"" };
          const res = await fetch('/tcsdb/divinvendata', {
              method: "POST",
              headers:{                  
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                entityNames:"itemInventory", actions: "SEARCH", sites:frontsitedata, locationTypes: locationtypedata, locations: locationsdata, itemTypes :"Finished Goods"
              })
            
          })          
          
          const invdata = await res.json();
          // console.log(invdata.data.Status);
          // if(invdata.data.Status === "RECORDNOTMATCH")
          // {
          //   setBtnsearch('');
          //   toast.error(`${selectinvsitedata} Location ${locationtypedata} Error Mismatch Records.`, { position: "top-center" });                     
          // }
          // else 
          if(invdata.length <=0)
          {
            setBtnsearch('');
            toast.error(`${selectinvsitedata} Location ${locationtypedata} There is No Records.`, { position: "top-center" });                     
          }
          else
          {
          setFinalinvdata(invdata);
          // console.log(invdata);
          setBtnsearch('');
          setIsLoading(false);
          toast.success(`${selectinvsitedata} Location ${locationtypedata} reports genrated Successfully...`, { position: "top-center" });                   
          }
      } 
      } catch (err) {
        setBtnsearch('');
        setIsLoading(false);
        toast.error(`Please Contact to Administrator - ${err} .`, { position: "top-center" });                     
        // console.log(err);
          
      }
  }



  const sapinventoryreport = async () => {        
    try {
        let frontsitedata = selectinvsitedata;
        let frontlocationdata = selectinvlocationdata;
        let locationtypedata = "";
        let locationsdata = "";
        let plant = plantdata;
        if(frontlocationdata === "Inventory")
        {
          locationtypedata = "Inventory";
          locationsdata = "FG Saleable Stock";
        }
        
        if(frontlocationdata === "Goods-intransit")
        {
          locationtypedata = "Goods-intransit";
          locationsdata = "Goods Intransit Location";
        }

        if(!frontsitedata ||!locationtypedata || !locationsdata || frontlocationdata === "--Select--"|| frontsitedata === "--Select--")
        {
            toast.error("Please Select the Site Data.", { position: "top-center" });
        }          
        else
        {
          setBtnsearch('none');
          setIsLoading(true);                

        const res = await fetch('/tcsdb/livesapinventryreports',{
              method: "POST",
              headers:{
                  // "Accept": "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                plant:plant
              })})
        
        const sapinvdata = await res.json();       
        
        if(sapinvdata.length <=0)
        {
          setBtnsearch('');
          setIsLoading(false);
          toast.error(`${selectinvsitedata} Location ${locationtypedata} There is No Records.`, { position: "top-center" });                     
        }
        else
        {
        setFinalsapinvdata(sapinvdata);
        // console.log(invdata);
        setBtnsearch('');
        setIsLoading(false);
        toast.success(`${selectinvsitedata} Location ${locationtypedata} reports genrated Successfully...`, { position: "top-center" });                   
        }
    } 
    } catch (err) {
      setBtnsearch('');
      setIsLoading(false);
      toast.error(`Please Contact to Administrator - ${err} .`, { position: "top-center" });                     
      // console.log(err);
        
    }
}


const saptraninventoryreport = async () => {        
  try {
      let frontsitedata = selectinvsitedata;
      let frontlocationdata = selectinvlocationdata;
      let locationtypedata = "";
      let locationsdata = "";
      let plant = plantdata;
      
      if(frontlocationdata === "Inventory")
      {
        locationtypedata = "Inventory";
        locationsdata = "FG Saleable Stock";
      }
      
      if(frontlocationdata === "Goods-intransit")
      {
        locationtypedata = "Goods-intransit";
        locationsdata = "Goods Intransit Location";
      }

      if(!frontsitedata ||!locationtypedata || !locationsdata || frontlocationdata === "--Select--"|| frontsitedata === "--Select--")
      {
          toast.error("Please Select the Site Data.", { position: "top-center" });
      }          
      else
      {
        setBtnsearch('none');
        setIsLoading(true);
    //   const data = { entityNames:"", actions:"", sites:"", locationTypes:"", locations:"", itemTypes:"" };
    //   const datedata = { sapfromDates:"", saptoDates:"" };
      const res = await fetch('/tcsdb/livesaptransitinventryreports', {
          method: "POST",
          headers:{                  
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
                plant:plant
              })          
      })          
      
      const saptraninvdata = await res.json();
    //   const planttraninvdata = saptraninvdata.filter((ptidata)=>(ptidata.TO_PLANT === plant))
    //   console.log(saptraninvdata);
      
      if(saptraninvdata.length <=0)
      {
        setBtnsearch('');
        setIsLoading(false);
        toast.error(`${selectinvsitedata} Location ${locationtypedata} There is No Records.`, { position: "top-center" });                     
      }
      else
      {
      setFinalsaptraninvdata(saptraninvdata);
      // console.log(invdata);
      setBtnsearch('');
      setIsLoading(false);
      toast.success(`${selectinvsitedata} Location ${locationtypedata} reports genrated Successfully...`, { position: "top-center" });                   
      }
  } 
  } catch (err) {
    setBtnsearch('');
    setIsLoading(false);
    toast.error(`Please Contact to Administrator - ${err} .`, { position: "top-center" });                     
    // console.log(err);
      
  }
}

    const pagauth = async() => {
        const pageids = "TcsInventoryReportPage";
        const res = await fetch('/user/pageaccessdatas/'+ pageids, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          credentials: "include"
        })        
        if(res.status === 404)
        {
          navigate('/Home');
          toast.error("You don't have access this page.", { position: "top-center" });
        }
      }


      const customStyles = {
        headRow: {
          style:{
            backgroundColor:'purple',
            color:'white',            
            height:80,                  
          },    
        },
        headCells:{
          style:{
            fontSize:'14px',
            
          }
        }
      }       

        const invcolumns = [
          {
              name: "Site",
              selector: "Site",
                            
            },
          {
            name: "Item_Code",
            selector: "itemCode",            
            
          },
          {
            name: "Item_Description",
            selector: "itemDescription",
            width:"240px",
            wrap:true,                        
          },
          {
            name: "Billing_UOM",
            selector: "uomCode",
          },
          {
            name: "Total_Quantity",
            selector: "totalQuantity",      
          },
          {
            name: "Batch_Number",
            selector: "batchNumber",
          },
          {
            name: "Batch_Mfg_Date",
            selector: "batchMfgDate",
            // sortable:true,
          },
          {
            name: "Batch_Exp_Date",
            selector: "batchExpDate",
          },          
          {
            name: "No_of_MonthsForExpiry",
            selector: "noOfMonthsForExpiry",
          },                  
        ];


        const sapinvcolumns = [
          {
              name: "Site",
              selector: "PLANT",
                            
            },
          {
            name: "Item_Code",
            selector: "ITEMCODE",            
            
          },
          {
            name: "Item_Description",
            selector: "ITEMNAME",
            width:"240px",
            wrap:true,                        
          },
          {
            name: "Billing_UOM",
            selector: "UOM",
          },
          {
            name: "Total_Quantity",
            selector: "INVQTY",      
          },
          {
            name: "Batch_Number",
            selector: "BATCH",
          },
          {
            name: "Batch_Mfg_Date",
            selector: "MFGDATE",
            // sortable:true,
          },
          {
            name: "Batch_Exp_Date",
            selector: "EXPDATE",
          },          
          {
            name: "Division",
            selector: "DIVNAME",
          },                  
        ];

        const saptraninvcolumns = [
          {
              name: "Site",
              selector: "TO_PLANT",
                            
            },
          {
            name: "Item_Code",
            selector: "ITEMCODE",            
            
          },
          {
            name: "Item_Description",
            selector: "ITEMNAME",
            width:"240px",
            wrap:true,                        
          },
          {
            name: "Billing_UOM",
            selector: "UOM",
          },
          {
            name: "Total_Quantity",
            selector: "INVQTY",      
          },
          {
            name: "Transfer_Date",
            selector: "BILLDATE",
          },
          {
              name: "From_Site",
              selector: "FROM_PLANT",
                            
            },
          {
            name: "LR_Number",
            selector: "LRNO",
            // sortable:true,
          },
          {
            name: "LR_Date",
            selector: "LRDATE",
          },          
          {
            name: "Transporter",
            selector: "TRASNPNAME",
          },                  
        ];



    useEffect (() => {
        pagauth();
        empdataHomePage();
        
        
      }, []);
      

  return (
    <>
    <div className="">
    <Navbar />   
    </div>
    
    <div className='d-flex justify-content-center align-items-top bg-white vh-100'>
    <div className='mt-3 w-100'>
    <div className='bg-white p-3 rounded w-100'>
    <div className='bg-info w-25 rounded-1 mt-1'>Site Wise Batch Wise Inventory Details:</div>
    <div className='d-flex mt-2 flex-column align-items-center'>    
    <div className='w-100'>
    <button className='btn btn-primary rounded-1 ms-5 mb-2' onClick={empsitemapdata}>Site Details Click here!</button>    
    {/* <select className='ms-5 w-15' onChange={(e)=> setSelectinvsitedata(e.target.value)} > */}
    <select className='ms-5 w-15' onChange={handlesitelistdata} >
    <option defaultValue={true}>--Select--</option>
    {
      values.map((opt,i)=><option key={i}>{opt.siteCode}</option>)
    }   
    </select>
    <select className='ms-5 w-15' onChange={(e)=> setSelectinvlocationdata(e.target.value)}>    
    <option defaultValue={true}>--Select--</option>
      <option>Inventory</option>
      <option>Goods-intransit</option>
    </select>
    <span className='ms-5 w-15'>Plant Code: {plantdata}</span>
                    
    
    </div>          
    <div>    
    <button className='btn btn-primary rounded-1 ms-5 mb-2' disabled={btnsearch} onClick={sapinventoryreport}>SAP Inventory Report</button>
    <button className='btn btn-primary rounded-1 ms-5 mb-2' disabled={btnsearch} onClick={saptraninventoryreport}>SAP Transit Inventory Report</button>
    <button className='btn btn-primary rounded-1 ms-5 mb-2' disabled={btnsearch} onClick={divwiseinventoryreport}>TCS Search Report</button>
    </div>
    <div className=' bg-info w-50 rounded-1 mt-1'>SAP Plant wise Live Inventory Details:</div>
    {(isLoading) ? <Loaders /> :
      <DataTableExtensions
      columns={sapinvcolumns}
    data={finalsapinvdata}
    // filter={false}
    exportHeaders={true}
    print={false}
    fileName={"Inventory_Report"}
      >
      <DataTable    
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"
    />
      </DataTableExtensions>}

      <div className='bg-info w-50 rounded-1 mt-1'>SAP Plant wise Live Transit Inventory Details:</div>
      
      <DataTableExtensions
      columns={saptraninvcolumns}
    data={finalsaptraninvdata}
    // filter={false}
    exportHeaders={true}
    print={false}
    fileName={"Inventory_Report"}
      >
      <DataTable    
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"
    />
      </DataTableExtensions>

      {/* <div className='bg-danger w-50 rounded-1 mt-1'>TCS Plant wise Live Inventory Details:</div>
      
      <DataTableExtensions
      columns={invcolumns}
    data={finalinvdata}
    // filter={false}
    exportHeaders={true}
    print={false}
    fileName={"Inventory_Report"}
      >
      <DataTable    
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"
    />
      </DataTableExtensions> */}


    </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Sapinventory